import './App.css';
import AuthenticationEnhanced from './AuthEnhanced';

function App() {
  const currentProject= "Eureka-001";
  return (
    <AuthenticationEnhanced project={currentProject}/>
  );
}

export default App;
